import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from './redux';
import { setFonts } from '@/redux/reducer/game';
import { getElementFonts, loadFonts } from '@/util/font';

type IFontsProps = {
  textContent: string;
};
export const useFonts = ({ textContent }: IFontsProps) => {
  const { fonts } = useAppSelector(state => state.game);
  const [isLoaded, setIsLoaded] = useState(false);
  const dispatch = useAppDispatch();
  const onLoadFonts = async () => {
    if (textContent) {
      const fontNames = getElementFonts(textContent);
      const filteredFonts = fontNames.filter(ele => !fonts.includes(ele));
      if (filteredFonts && filteredFonts.length > 0) {
        await loadFonts(fontNames);
        dispatch(setFonts([...fonts, ...filteredFonts]));
      }
    }
    setIsLoaded(true);
  };

  useEffect(() => {
    onLoadFonts();
  }, []);
  return { isLoaded };
};
